import React from "react";

type Props = {};

const CustomNavBar = (props: Props) => {
  return <div>CustomNavBar</div>;
};

export default CustomNavBar;
